import store from '@/state/store'

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/home'),
  },
  {
    path: '/',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated) {
          // Redirect to the home page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('AUTH_LOGOUT')
        // const authRequiredOnPreviousRoute = routeFrom.matched.some(
        //   (route) => route.push('/login')
        // )

        next({ name: 'login' });

        // Navigate back to previous page, or home as a fallback
        // next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/customers',
    name: 'customers',
    meta: { authRequired: true },
    component: () => import('./views/customers/Customers')
  },
  {
    path: '/orders',
    name: 'orders',
    meta: { authRequired: true },
    component: () => import('./views/orders/Orders')
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { authRequired: true },
    component: () => import('./views/settings/Settings')
  },
  {
    path: '/reports',
    name: 'reports',
    meta: { authRequired: true },
    component: () => import('./views/reports/Reports')
  },
  {
    path: '/activities',
    name: 'activities',
    meta: { authRequired: true },
    component: () => import('./views/activities/Activities')
  },
  {
    path: '/products',
    name: 'products',
    meta: { authRequired: true },
    component: () => import('./views/products/Products')
  },
  {
    path: '/cart',
    name: 'cart',
    meta: { authRequired: true },
    component: () => import('./views/sales/Cart')
  },
  {
    path: '/checkout',
    name: 'checkout',
    meta: { authRequired: true },
    component: () => import('./views/sales/Checkout')
  },
  {
    path: '/reports/order-status',
    name: 'order-status',
    meta: { authRequired: true },
    component: () => import('./views/reports/OrderStatus')
  },
  {
    path: '/reports/order-history',
    name: 'order-history',
    meta: { authRequired: true },
    component: () => import('./views/reports/OrderHistory')
  },
  {
    path: '/reports/invoice-history',
    name: 'invoice-history',
    meta: { authRequired: true },
    component: () => import('./views/reports/InvoiceHistory')
  },
  {
    path: '/reports/customers-list',
    name: 'customers-list',
    meta: { authRequired: true },
    component: () => import('./views/reports/CustomersList')
  },
  {
    path: '/reports/customer-prices',
    name: 'customers-prices',
    meta: { authRequired: true },
    component: () => import('./views/reports/CustomerPrices')
  },
  {
    path: '/reports/customer-prices-atacarejo',
    name: 'customers-prices-atacarejo',
    meta: { authRequired: true },
    component: () => import('./views/reports/CustomerPricesAtacarejo')
  },
  {
    path: '/reports/products-stock',
    name: 'products-stock',
    meta: { authRequired: true },
    component: () => import('./views/reports/ProductsStock')
  },
  {
    path: '/reports/products',
    name: 'products',
    meta: { authRequired: true },
    component: () => import('./views/reports/Products')
  },
  {
    path: '/reports/abc-curve-customers',
    name: 'abc-curve-customers',
    meta: { authRequired: true },
    component: () => import('./views/reports/AbcCurveCustomers')
  },
  {
    path: '/reports/abc-curve-products',
    name: 'abc-curve-products',
    meta: { authRequired: true },
    component: () => import('./views/reports/AbcCurveProducts')
  },
  {
    path: '/reports/pendencies',
    name: 'pendencies',
    meta: { authRequired: true },
    component: () => import('./views/reports/Pendencies')
  },
  {
    path: '/reports/goals',
    name: 'goals',
    meta: { authRequired: true },
    component: () => import('./views/reports/Goals')
  },
  {
    path: '/reports/commissions',
    name: 'commissions',
    meta: { authRequired: true },
    component: () => import('./views/reports/Commissions')
  },
  {
    path: '/select-customer',
    name: 'select-customer',
    meta: { authRequired: true },
    component: () => import('./views/customers/Customers')
  },
  {
    path: '/seller-customers',
    name: 'seller-customers',
    meta: { authRequired: true },
    component: () => import('./views/customers/SellerCustomers')
  },
  {
    path: '/new-customer',
    name: 'new-customer',
    meta: { authRequired: true },
    component: () => import('./views/customers/NewCustomer')
  },
  {
    path: '/policy',
    name: 'policy',
    meta: { authRequired: true },
    component: () => import('./views/policy/Policy')
  },
  {
    path: '/crm-open',
    name: 'crm-open',
    meta: { authRequired: true },
    component: () => import('./views/crm/Crm')
  },
  {
    path: '/crm-closed',
    name: 'crm-closed',
    meta: { authRequired: true },
    component: () => import('./views/crm/Crm')
  },
  {
    path: '/select-customer-crm',
    name: 'select-customer-crm',
    meta: { authRequired: true },
    component: () => import('./views/customers/CustomersCrm')
  },
]
